import { render, staticRenderFns } from "./FeedbackSubmit.vue?vue&type=template&id=70413a26&scoped=true"
import script from "./FeedbackSubmit.vue?vue&type=script&lang=js"
export * from "./FeedbackSubmit.vue?vue&type=script&lang=js"
import style0 from "./FeedbackSubmit.vue?vue&type=style&index=0&id=70413a26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70413a26",
  null
  
)

export default component.exports